export const PAGE_DESCRIPTION = "page:description";
export const PAGE_FORM = "page:form";
export const PAGE_IDENTIFICATION = "page:identification";
export const PAGE_NAME = "page:name";
export const PAGE_SCHEMA = "page:schema";
